"use strict";
(function(global) {
    class CyberPakietCtiEventsController {
        constructor(config) {
            this.settings = {};
            this.init(config);
        }

        init(config) {
            // noinspection JSUnusedLocalSymbols
            const controller = this;
            this.createGrid(config);
        }

        createGrid(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Id",
                    "dataIndex": "id",
                    "dataType": "number",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    "width": "150"
                }, {
                    "label": "Zasób",
                    "dataIndex": "asset",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    "width": "300"
                }, {
                    "label": "Typ assetu",
                    "dataIndex": "asset_type",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    "width": "200"
                }, {
                    "label": "Dane",
                    "dataIndex": "data",
                    "dataType": "textarea",
                    "isEditable": false,
                    "width": "*"
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config.table_data_url,
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId"
            });

            // noinspection JSUnusedLocalSymbols
            const grid = new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': 'grid-container',
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                'enableMultiline': true,
                "showAllRows": config.show_all_rows || false,
                "pageSize": (config.show_all_rows) ? 99999999 : 20,
                'listeners': {
                    'onDataChanged': function () {

                    },
                    'onDataSaved': function () {

                    },
                    'onDataInvalid': function () {

                    },
                    'onDataError': function () {

                    },
                    'onSelectionChange': function (ids) {

                    }
                }
            });

            grid.grid.attachEvent("onXLE", function (gridObject, addedRowsCount) {
                gridObject.forEachRow(function (id) {
                    console.log('grid.cells(' + id + ', 3).cell.className = \'json\'');
                    gridObject.cells(id, 3).cell.className = 'json';
                });
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.CyberPakietCtiEventsController = CyberPakietCtiEventsController || {};

})(window);
